import {Pipe, PipeTransform} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';
import {AddSpacesPipe} from '../addSpaces/addSpaces.pipe';

@Pipe({
  name: 'price',
  pure: false
})
export class PricePipe implements PipeTransform {
  constructor(private authService: AuthService, private addSpacesPipe: AddSpacesPipe) {}

  transform(value: number = 0,
            noCurrency: boolean = false,
            decimalPlaces: number = 2) {
    let number: string = Number(value / 100).toFixed(decimalPlaces);
    number = this.addSpacesPipe.transform(number);
    return number + (noCurrency ? '' : this.authService.currencySymbol);
  }

  transformToNumber(value: number = 0) {
    return Number(value / 100);
  }
}
